import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  roundedCorners: {
    borderRadius: 50,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
  },
  iconSpacing: {
    marginRight: theme.spacing(1),
  },
  dialogText: {
    textAlign: 'left',
  },
  rightPanelContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    overflowY: 'auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  titleContainer: {
    margin: '0 auto',
    maxWidth: 640,
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  justifyStart: {
    justifyContent: 'flex-start',
  },
  noPaddingLeft: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
    },
  },
  topBottomSpacing: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  bottomSpacing: {
    paddingBottom: theme.spacing(1),
  },
  topSpacing: {
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(2),
    },
  },
  toggleLabel: {
    top: -21,
    left: -14,
    fontSize: 12,
    color: theme.palette.secondary.main,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  subScoreFormPadding: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  toggleFormControl: {
    paddingTop: 20,
    width: '100%',

    '& .jbuilderGroup': {
      '& .jbuilderCol': {
        flex: 1,

        '& .jbuilderErrorText': {
          color: theme.palette.error.main,
        },

        '& .MuiFormControl-root': {
          width: '100%',

          '& .MuiInputBase-root': {
            height: 56,
          },
        },
      },
    },
  },

  btn: {
    display: 'flex',
    justifySelf: 'center',
  },
}));

export default useStyles;
